import script from "./AdminRewards.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminRewards.vue?vue&type=script&setup=true&lang=ts"

import "./AdminRewards.vue?vue&type=style&index=0&id=79e836f2&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79e836f2"]])

export default __exports__